export default "__VITE_ASSET__9f49e5fc__"